var React = require('react');

function Orders (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M18.75,14.261H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75","key":1}),React.createElement("line",{"className":"a","x1":"17.25","y1":"21.011","x2":"17.25","y2":"20.261","key":2}),React.createElement("line",{"className":"a","x1":"17.25","y1":"14.261","x2":"17.25","y2":"13.511","key":3}),React.createElement("circle",{"className":"a","cx":"17.25","cy":"17.261","r":"6","key":4}),React.createElement("line",{"className":"a","x1":"5.25","y1":"10.511","x2":"10.5","y2":"10.511","key":5}),React.createElement("line",{"className":"a","x1":"5.25","y1":"14.261","x2":"8.25","y2":"14.261","key":6}),React.createElement("line",{"className":"a","x1":"5.25","y1":"18.011","x2":"8.25","y2":"18.011","key":7}),React.createElement("path",{"className":"a","d":"M9.75,23.261H2.25a1.5,1.5,0,0,1-1.5-1.5V6.011a1.5,1.5,0,0,1,1.5-1.5H6a3.75,3.75,0,0,1,7.5,0h3.75a1.5,1.5,0,0,1,1.5,1.5v2.25","key":8}),React.createElement("path",{"className":"a","d":"M9.75,3.761a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375","key":9})]);
}

Orders.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Orders;

Orders.default = Orders;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/orders.svg
// module id = 1078
// module chunks = 0